/**
 * Shapes cart bridge for Caffeine bundle adds.
 *
 * Caffeine dispatches caffeine:bundle:added and cart:refresh.
 * Jurni dispatches jurni:shopify-cart-updated on window after its own adds.
 * Shapes refreshes on theme:update:cart, then shapes:cart:update.
 * The drawer opens on theme:open:cart-drawer, only after that refresh.
 *
 * Notifications for the same change are coalesced. A later cart mutation that
 * finishes while a refresh is in flight keeps one trailing refresh, so the
 * drawer renders the latest cart. An echo of the refresh itself does not
 * start another one. This file does not own bundle commerce rules.
 */
(function (global) {
  "use strict";

  function createShapesCartAdapter(doc, schedule) {
    var queued = false;
    var inflight = false;
    var pending = false;
    var later = schedule || global.queueMicrotask || function (fn) {
      Promise.resolve().then(fn);
    };

    function drawerAlreadyOpen(doc) {
      var view = doc.defaultView;
      var drawer = doc.querySelector && doc.querySelector("[data-cart-drawer]");
      if (!drawer || !view || typeof view.getComputedStyle !== "function") return false;
      return view.getComputedStyle(drawer).display !== "none";
    }

    function requestRefresh(kind) {
      if (inflight) {
        if (kind === "mutation") pending = true;
        return;
      }
      if (queued) return;
      queued = true;
      later(function () {
        queued = false;
        if (inflight) {
          pending = true;
          return;
        }
        begin();
      });
    }

    function begin() {
      inflight = true;
      var settled = false;

      function finish(open) {
        if (settled) return;
        settled = true;
        inflight = false;
        doc.removeEventListener("shapes:cart:update", onUpdate);
        doc.removeEventListener("theme:cart:error", onError);
        doc.removeEventListener("shapes:cart:unlock", onUnlock);
        var follow = pending;
        pending = false;
        if (open) {
          doc.dispatchEvent(new CustomEvent("caffeine:cart:open"));
          if (!drawerAlreadyOpen(doc)) {
            later(function () {
              doc.dispatchEvent(new CustomEvent("theme:open:cart-drawer"));
            });
          }
        } else {
          var errors = doc.getElementById && doc.getElementById("cart-errors");
          if (errors) errors.textContent = "Your cart could not be refreshed. Please try again.";
          doc.dispatchEvent(new CustomEvent("caffeine:cart:refresh-failed"));
        }
        if (follow) begin();
      }

      function onUpdate() {
        finish(true);
      }

      function onError() {
        finish(false);
      }

      function onUnlock() {
        finish(false);
      }

      doc.addEventListener("shapes:cart:update", onUpdate);
      doc.addEventListener("theme:cart:error", onError);
      doc.addEventListener("shapes:cart:unlock", onUnlock);
      doc.dispatchEvent(new CustomEvent("theme:update:cart"));
    }

    doc.addEventListener("caffeine:bundle:added", function () {
      requestRefresh("mutation");
    });
    doc.addEventListener("caffeine:cart:external-change", function () {
      requestRefresh("mutation");
    });
    // Jurni landing pages add through /cart/add.js, then announce it on window.
    var view = doc.defaultView;
    if (view && typeof view.addEventListener === "function") {
      view.addEventListener("jurni:shopify-cart-updated", function () {
        requestRefresh("mutation");
      });
    }
    doc.addEventListener("cart:refresh", function () {
      requestRefresh("refresh");
    });
    doc.addEventListener("theme:cart-drawer:open", function () {
      doc.dispatchEvent(new CustomEvent("caffeine:cart:open"));
    });
    doc.addEventListener("cart-is-open", function () {
      doc.dispatchEvent(new CustomEvent("caffeine:cart:open"));
    });
    doc.addEventListener("shopify:section:load", function (event) {
      var target = event && event.target;
      var detail = event && event.detail;
      var root = target && target !== doc && typeof target.querySelector === "function"
        ? target
        : detail && typeof detail.querySelector === "function"
          ? detail
          : null;
      if (!root) return;
      if (!root.querySelector('[data-caffeine-recommendations][data-placement="cart_drawer"]')) return;
      doc.dispatchEvent(new CustomEvent("caffeine:cart:changed"));
    });
    return { requestRefresh: requestRefresh };
  }

  var api = { createShapesCartAdapter: createShapesCartAdapter };
  global.CaffeineShapesCart = api;
  if (typeof module !== "undefined" && module.exports) module.exports = api;

  if (typeof document !== "undefined" && document.addEventListener) {
    var start = function () {
      createShapesCartAdapter(document);
    };
    if (document.readyState === "loading") {
      document.addEventListener("DOMContentLoaded", start, { once: true });
    } else {
      start();
    }
  }
})(typeof globalThis !== "undefined" ? globalThis : this);
